var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplementaryMedicineWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "complementary-medicine-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".complementary-medicine-white_svg__st7{fill:none;stroke:#fff;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.2 659.4H38.9V362.7h321.8V38.9h297.7v283.3M360.7 894.5v89.6h297.7V830.9M880 362.7h103.1v296.7H831.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M661 548.1s-95.6 65.9-193.4 55.4C379 594 308 671 308 671s-55.1-95.4 72.8-185.8 296.7 8.9 393.5-69.6c0 0 12.5 284.3-188.8 339.7s-260.3.4-260.3.4-37 12.3-45.4 80.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplementaryMedicineWhite);
export default ForwardRef;